import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCustomerName = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.information.customerName;

export const customerName = setCalculationModeCustomerName(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_CUSTOMER_NAME',
  ''
);
